import { useEffect, type PropsWithChildren } from 'react';
import { App as AntdApp, ConfigProvider } from 'antd';
import faIR from 'antd/locale/fa_IR';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/core/query/queryClient';
import { useUiStore } from '@/core/auth/uiStore';
import { createThemeConfig } from '@/app/theme/theme';

export const AppProviders = ({ children }: PropsWithChildren): React.ReactElement => {
  const colorMode = useUiStore((state) => state.colorMode);

  useEffect(() => {
    document.documentElement.dataset.theme = colorMode;
    document.documentElement.style.colorScheme = colorMode;
  }, [colorMode]);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider direction="rtl" locale={faIR} theme={createThemeConfig(colorMode)}>
        <AntdApp>{children}</AntdApp>
      </ConfigProvider>
    </QueryClientProvider>
  );
};
